<template>
  <div class="main-container">
    <div class="main-content">
      <div class="menu-app">
        <button>_</button>
        <button>?</button>
        <button>X</button>
      </div>

      <div class="alert-container">
        <div class="square">
          <p>!</p>
        </div>

        <div class="settings">
          <box-icon type='solid' name='cog' color="#f9f9f9" size="20px"></box-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style src="./style.scss" lang="scss" />
